export enum QaCriteriaDefinitionProperty {
  Label = 1,
  Name = 2,
  Points = 3
}